import React, { Component } from "react";
import { Col, Row, Card, Table, Spin, Icon } from 'antd';
import Login from 'views/Login';
import _authService from 'modules/AuthService';
import _notification from 'modules/notification';
import { LoadingOutline } from 'antd/';
import { NavLink } from "react-router-dom"
import { routes } from "../../routes/Routes";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class SharedPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      resData: {}
    }
  }


  componentDidMount() {
    this.getInfo();
    //console.log(this.props);
  }

  getInfo = async (ev) => {

    this.setState({ isLoading: true });
    try {
      //console.log(this.props);
      const response = await _authService.getPortalConfigurationByKey(this.props.location.pathname.replace('/', ''));
      //console.log("API Response: ", response);
      if (response.status == 200 && response.data) {
        this.setState({ isLoading: false, resData: { ...response.data } })
      }
      else {
        this.setState({ isLoading: false });
        _notification.showMessage('error', response.data.Message);
      }
    } catch (e) {
      this.setState({ isLoading: false })

    }

  }

  render() {
    if (this.state.isLoading)
      return <Spin indicator={antIcon} tip="&nbsp;Please wait..." />
    return (<>

      <div style={{ minHeight: '580px' }}>
        <div className="pt-3 pb-3 p-sm-4 p-md-5 h-75">

          <Row className="align-self-center mb10">
            <Col xs={{ span: 24 }} sm={{ span: 22, offset: 1 }} md={{ span: 16, offset: 4 }}>
              {this.props.location.pathname == '/aboutus' && <h2>About Us</h2>}

              {this.props.location.pathname == '/contactus' && <h2>Contact Us</h2>}

              {this.props.location.pathname == '/privacypolicy' && <h2>Privacy Policy</h2>}

              {this.props.location.pathname == '/termsandconditions' && <h2>Terms & Conditions</h2>}

              {this.props.location.pathname == '/refundpolicies' && <h2>Cancellation/Refund Policies</h2>}
            </Col>
          </Row>

          <Row className="align-self-center">
            <Col xs={{ span: 24 }} sm={{ span: 22, offset: 1 }} md={{ span: 16, offset: 4 }}>
              <div>
                <div dangerouslySetInnerHTML={{ __html: this.state.resData.Value }}></div>
              </div>
            </Col>
          </Row>
        </div>
        <hr className="border-info mt-3 w-75" />

        <Row className="text-center mt-3 pb-2">
          <Col xs={{ span: 0 }} md={{ span: 3 }}>
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 6 }} className="h5">
            <div className="pt-1">
              <NavLink className="text-primary" to={routes.home.path}>Home</NavLink>
            </div>
            <div className="pt-1">
              <NavLink className="text-primary" to={routes.aboutUs.path}>About Us</NavLink>
            </div>
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 6 }} className="h5">
            <div className="pt-1">
              <NavLink className="text-primary" to={routes.termsAndConditions.path}>Terms & Conditions</NavLink>
            </div>

            <div className="pt-1">
              <NavLink className="text-primary" to={routes.privacyPolicy.path}>Privacy Policy</NavLink>
            </div>
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 6 }} className="h5">
            <div className="pt-1">
              <NavLink className="text-primary" to={routes.cancellationRefundPolicies.path}>Cancellation/Refund Policies</NavLink>
            </div>

            <div className="pt-1">
              <NavLink className="text-primary" to={routes.contactUs.path}>Contact Us</NavLink>
            </div>
          </Col>

          <Col xs={{ span: 0 }} md={{ span: 3 }}>
          </Col>
        </Row>
      </div>
    </>);
  }
}

export default SharedPage;